import React from "react";
import { Modal } from "./modal-template.styles";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import cx from "classnames";
import { Grid } from "@material-ui/core";
import { ModalTemplateProps } from "./modal-template.props";
import { CloseButton } from "./components/close-button/close-button.component";

export const ModalTemplate: React.FC<ModalTemplateProps> = (props) => {
  return (
    <Modal
      open={props.open}
      onClose={props.closeModal}
      aria-labelledby={props.header}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open}>
        <div className={cx("modalDialogContainer", props.size)}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h1 className="text-center">
                {props.header}
                <CloseButton showIf={!!props.closeModal} closeModal={props.closeModal} />
              </h1>
            </Grid>
            {props.children}
          </Grid>
        </div>
      </Fade>
    </Modal>
  );
};
